import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import cloneDeep from 'lodash/cloneDeep';
import { Input, Textarea, AlertNotice } from 'shared/components';
import { ValidationService } from 'shared/services';
import * as tcRenewalAction from 'features/tc-renewal/duck';
import { filterOpenEvents } from 'features/tc-renewal/selectors';
import AdmissionTicketSample from './AdmissionTicketSample';

import './TCMessageTestDates.scss';

const MAX_LENGTH = 360;

const checkSameMessage = (events) => {
  let result = true;
  events.forEach((event, index) => {
    if (events[index + 1] && event.message !== events[index + 1].message) {
      result = false;
    }
  });
  return result;
};

const getFirstMessage = (events) => {
  const foundEv = events.find((ev) => ev.message);
  return foundEv ? foundEv.message : '';
};

class TCMessageTestDates extends Component {
  constructor(props) {
    super(props);
    const { events } = props;

    this.state = {
      events: cloneDeep(events),
      isDirty: false,
      sameMessage: events.length && checkSameMessage(events) ? events[0].message || '' : '',
      isSameMessage: events.length && checkSameMessage(events),
      errors: {},
    };

    if (!props.tcCycleEvents.length) {
      props.actions.getTcCycleEvents(props.tcCycle.id);
    }

    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.onSameMessageChange = this.onSameMessageChange.bind(this);
    this.onMessageChange = this.onMessageChange.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.checkIsDirty = this.checkIsDirty.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { events } = this.props;
    const { isDirty } = this.state;

    if (events && events.length && !isDirty && prevProps.events !== events) {
      this.setState({
        events: cloneDeep(events),
        sameMessage: checkSameMessage(events) ? events[0].message || '' : '',
        isSameMessage: checkSameMessage(events),
      });
    }
  }

  onSameMessageChange(e) {
    const { value } = e.target;

    if (value && !ValidationService.specialCharsPermissive(value)) {
      this.setState({
        errors: {
          sameMessage: 'errors.specialCharactersNotAllowed2',
        },
      });
      return;
    }

    this.setState({
      sameMessage: value,
      isDirty: true,
      errors: {},
    });
  }

  onMessageChange(e) {
    const { name, value } = e.target;
    const { events } = this.state;

    const index = parseInt(name);

    if (value && !ValidationService.specialCharsPermissive(value)) {
      this.setState({
        errors: {
          [index]: 'errors.specialCharactersNotAllowed2',
        },
      });
      return;
    }

    events[index].message = value;
    this.setState({
      events,
      isDirty: true,
      errors: {},
    });
  }

  handleCheckbox() {
    this.setState((prevState) => ({
      isSameMessage: !prevState.isSameMessage,
      isDirty: true,
    }));
  }

  async handleContinue() {
    const { actions, tcCycle, tcCycleEvents } = this.props;
    const { events, isSameMessage, sameMessage } = this.state;

    if (isSameMessage) {
      events.map((event) => (event.message = sameMessage));
    }

    const eventsList = [...tcCycleEvents];
    tcCycleEvents.forEach((ev, idx) => {
      const foundEv = events.find((openEv) => openEv.id === ev.id);
      if (foundEv) {
        eventsList.splice(idx, 1, foundEv);
      }
    });

    const updated = await actions.setTcCycleEvents(tcCycle.id, eventsList);
    return !!updated;
  }

  checkIsDirty() {
    return this.state.isDirty;
  }

  render() {
    const { events, isSameMessage, sameMessage } = this.state;
    const { tcCycle } = this.props;

    return (
      <section className="message-test-dates-container">
        <h4>{this.props.t('testCenter.messagesTestDates.title')}</h4>
        <p>{this.props.t('testCenter.messagesTestDates.subtitle')}</p>

        {events.length ? (
          <div>
            <div>
              <Input
                type="checkbox"
                name="isSameMessage"
                id="isSameMessage"
                checked={!isSameMessage}
                onChange={this.handleCheckbox}>
                <label htmlFor="isSameMessage">
                  {this.props.t('testCenter.messagesTestDates.useDifferentMessagesLabel')}
                </label>
              </Input>
            </div>
            {isSameMessage ? (
              <div>
                <div className="test-dates-label">
                  {this.props.t('testCenter.messagesTestDates.testDatesOptIn')}
                </div>
                <div className="test-dates">
                  {events.map((event, index) => (
                    <span key={index}>{event.testingEvent.name}</span>
                  ))}
                </div>
                <div className="test-dates-messages">
                  <div className="text-strong">
                    {this.props.t('testCenter.messagesTestDates.genericMessageLabel')}
                  </div>
                  <Textarea
                    className="mb-1"
                    name="sameMessage"
                    value={sameMessage}
                    onChange={this.onSameMessageChange}
                    maxLength={MAX_LENGTH}
                    error={this.state.errors.sameMessage}
                  />
                </div>
              </div>
            ) : (
              <div>
                {events.map((event, index) => (
                  <div className="test-dates-messages" key={index}>
                    <div className="text-strong">{event.testingEvent.name}</div>
                    <Textarea
                      className="mb-1"
                      name={index.toString()}
                      value={event.message ? event.message : ''}
                      onChange={this.onMessageChange}
                      maxLength={MAX_LENGTH}
                      error={this.state.errors[index]}
                    />
                  </div>
                ))}
              </div>
            )}
            <AdmissionTicketSample
              message={isSameMessage ? sameMessage : getFirstMessage(events)}
              testCenterName={tcCycle.testCenterProgram.testCenter.name}
              location={tcCycle.locations[0]}
            />
          </div>
        ) : (
          <AlertNotice message={this.props.t('testCenter.messagesTestDates.noTestDatesMessage')} />
        )}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    tcCycle: state.tcRenewal.tcCycle,
    tcCycleEvents: state.tcRenewal.tcCycleEvents,
    events: filterOpenEvents(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...tcRenewalAction }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withTranslation(null, { withRef: true })(TCMessageTestDates));

TCMessageTestDates.propTypes = {
  tcCycle: PropTypes.shape({}).isRequired,
  tcCycleEvents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  events: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  actions: PropTypes.shape({
    getTcCycleEvents: PropTypes.func,
    setTcCycleEvents: PropTypes.func,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
